var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUser && _vm.currentUser.id)?_c('HomePageToggle'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }